import { render } from "./AdvertiserUserAccountCreator.vue?vue&type=template&id=4b35d044"
import script from "./AdvertiserUserAccountCreator.vue?vue&type=script&lang=js"
export * from "./AdvertiserUserAccountCreator.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/releases/53/app.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__